import { DetailAnscNotificationsSubscriptionCrumbs } from 'subscription/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import DetailAnscNotificationsShared from 'shell/components/shared/ansc-notifications/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const AnscNotificationsDetailPage = (): ReactElement => {
  return (
    <Fragment>
      <DetailAnscNotificationsShared
        scope={IdAmbito.Iscrizioni}
        items={DetailAnscNotificationsSubscriptionCrumbs}
      />
    </Fragment>
  );
};

AnscNotificationsDetailPage.displayName = 'Ansc Notification edit page component';

export default AnscNotificationsDetailPage;
